import axios from 'axios';
import catchify from 'catchify';
import { isValidEmail } from '../util/global';

export default {
  data() {
    return {
      emailAddress: this.user?.email || '',
      isProcessing: false,
      isEmailSubmitted: false,
      utmSource: '',
      utmCampaign: '',
      utmMedium: '',
    };
  },
  mounted() {
    this.utmSource = this.$route?.query.utm_source || this.$cookies?.get('utm_source');
    this.utmCampaign = this.$route?.query.utm_campaign || this.$cookies?.get('utm_campaign');
    this.utmMedium = this.$route?.query.utm_medium || this.$cookies?.get('utm_medium');
  },
  computed: {
    isEmailAddressValid() {
      return isValidEmail(this.emailAddress);
    },
  },
  methods: {
    $_formHeaders() {
      // an: request CSRF token every time in case a login is detected from another tab
      return {
        headers: {
          'X-CSRFToken': this.$cookies?.get('csrftoken'),
          'Content-Type': 'multipart/form-data',
        },
      };
    },
    $_createFormDataWithUtm() {
      const formData = new FormData();
      const utmQueryParams = [
        { name: 'source', value: this.utmSource },
        { name: 'campaign', value: this.utmCampaign },
        { name: 'medium', value: this.utmMedium },
      ];
      utmQueryParams.forEach((paramObj) => {
        if (paramObj.value) {
          formData.append(paramObj.name, paramObj.value);
        }
      });

      return formData;
    },
    $_validateEmail(email) {
      return isValidEmail(email);
    },
    async $_asyncSubmitEmail() {
      if (!this.isEmailAddressValid) {
        this.$toastr.w('Please use a valid email address.');
        return;
      }

      const formData = this.$_createFormDataWithUtm();
      formData.append('email', this.emailAddress);

      await this.$_sendEmailRequest('/accounts/signup/email-subscribe/', formData);
    },
    async $_sendEmailRequest(url, formData, showToastMessage = true) {
      this.isProcessing = true;

      const [error] = await catchify(
        axios.post(url, formData, this.$_formHeaders()),
      );

      if (error) {
        this.$toastr.e('Something has gone wrong with this request. Please try again.');
      } else {
        if (showToastMessage) {
          this.$toastr.s(
            'You\'re signed up to receive the hottest deals, straight into your inbox!',
          );
        }
        this.isEmailSubmitted = true;
        this.$emit('email-submitted');
      }

      this.isProcessing = false;

      return error;
    },
  },
};
